import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {SessionService} from '../auth/state/session.service';

@Injectable({
    providedIn: 'root'
})
export class ResourceResolveService  {

    constructor(private sess: SessionService) {
    }

    resolve(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.sess.loadApplicationResources();
    }
}
